var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-component"},[_vm._t("default"),_c('SVersionModalTip',{ref:"SVersionModalTip"}),_c('SVersionDialogTip',{ref:"SVersionDialogTip"}),_c('SVersionModalAddress',{ref:"SVersionModalAddress"}),_c('SVersionModalInviteTeam',{ref:"SVersionModalInviteTeam",on:{"inviteSuccess":_vm.init}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }